export default {
  getAdminAuth: (state) => state.auth,
}



// WEBPACK FOOTER //
// ./src/store/adminPermissionStore/getters.js